import axiosServer from "../../axios/axiosServer";
import APIs from "../../constant/endpoint";

export const changePassword = async (data) => {
  const res = await axiosServer.post(APIs.changePassword, data);
  return res.data;
};
